import React, { ReactNode, useState } from 'react';
import { FormPageContextProvider } from '@wix/bex-core/react';
import { PageWrapperBase } from '../PageWrapper';
import { FormPageState } from '@wix/bex-core';

export function FormPageProvider({
  children,
  state,
}: {
  children: ReactNode;
  state?: FormPageState;
}) {
  const [formPage] = useState(() => state ?? new FormPageState());

  return (
    <FormPageContextProvider value={formPage}>
      <PageWrapperBase>{children}</PageWrapperBase>
    </FormPageContextProvider>
  );
}
